export default __webpack_public_path__ + "static/media/monitor-icon.2ddeec95.png";